import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_CLIENT_PROTECTION_ACTION_TYPE } from '../actions/clientProtection.actions';

const initialState = null;

const clientProtectionReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_CLIENT_PROTECTION_ACTION_TYPE.SET_CLIENT_PROTECTION:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default clientProtectionReducer;
